export const emptyArrayForLoop = [
  { isShow: true, value: 5 },
  { isShow: true, value: 6 },
  { isShow: false, value: 7 },
  { isShow: true, value: 8 },
  { isShow: false, value: 9 },
  { isShow: true, value: 10 },
  { isShow: false, value: 11 },
  { isShow: true, value: 12 },
  { isShow: false, value: 13 },
  { isShow: true, value: 14 },
  { isShow: false, value: 15 },
  { isShow: true, value: 16 },
  { isShow: false, value: 17 },
  { isShow: true, value: 18 },
  { isShow: false, value: 19 },
  { isShow: true, value: 20 },
  { isShow: false, value: 21 },
  { isShow: true, value: 22 },
  { isShow: false, value: 23 },
  { isShow: true, value: 24 },
  { isShow: false, value: 25 },
  { isShow: true, value: 26 },
  { isShow: false, value: 27 },
  { isShow: true, value: 28 },
  { isShow: false, value: 29 },
  { isShow: true, value: 30 },
];
